require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-10-questions-with-faye-prince.json") })
        }
      }, "path---news-10-questions-with-faye-prince");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-10-questions-with-faye-prince!./.cache/json/news-10-questions-with-faye-prince.json
// module id = 1409
// module chunks = 231608221292675